<div class="backgroundDialog" style="width: 100%; padding: 0px;margin: auto;">

    <div style="text-align: center; width: 20%;display: inline-block;  ">
        <mat-card style="border-radius: 0px 30px 30px 0px ; color: white;
                        background-color: rgb(46, 163, 80); font-size: 20px;">
            Solicitar&nbsp;Exclusão&nbsp;de&nbsp;Monitoria
        </mat-card>
    </div>

    <div style="text-align: right; width: 78%; display: inline-block; ">
        <button [mat-dialog-close]="true">
            <img src="../../assets/img/icones/fecharJanela.png" width="100%">
        </button>
    </div>

    <div style="background-color: rgb(51, 68, 75); height: 30px; width: 100%; color: white; text-align: center;">
        <div style="margin-top: 7px; ">Solicitação de Exclusão da Monitoria</div>
    </div>

    <div style="width: 100%;" style="padding: 2%;">
        <table style="width: 99.8%; margin: auto;">
            <tr>
                <td style="width:100%">
                    <div>
                        <table style="text-align: left; width: 100%; height: 98%;">
                            <tr style="cursor: pointer;">
                                <td style="width: 100%; height: 100%;">
                                    <mat-card class="mat-elevation-z5" style="font-size: 12px; height: 100%;">
                                        <form [formGroup]="formSolicitaExclusao" novalidate (ngSubmit)="solicitarExclusao()">
                                            <div style="width: 100%; text-align: center;">
                                                <label style="color: red;">
                                                    <b> ATENÇÃO </b><br/>
                                                    Caso a solicitação de exclusão seja aprovada, não será possível recuperar os dados da monitoria.
                                                </label>
                                            </div>
                                            <br />
                                            <div>
                                                <img src="../../assets/img/icones/editar.png" width="27px">&nbsp;
                                                <mat-form-field appearance="outline"
                                                    style="width: 250px;  font-size: 12px;">
                                                    <mat-label>Motivo da Exclusão</mat-label>
                                                    <input matInput placeholder="Digite o motivo da exclusão..." formControlName="motivoExclusao" required>
                                                </mat-form-field>
                                            </div>
                                            <br />
                                            <div>
                                                <div style="width: 100%; font-size: 12px; align-items: center;">
                                                    <button mat-raised-button  type="submit" style="background-color:rgb(46, 163, 80);  color: white;" >
                                                        Solicitar Exclusão
                                                    </button>
                                                </div>
                                            </div>
                                        </form>
                                    </mat-card>
                                </td>
                            </tr>
                        </table>
                    </div>
                </td>
            </tr>
        </table>
    </div>
</div>